import { render, staticRenderFns } from "./OrganizationStatistic.vue?vue&type=template&id=04251a02&"
import script from "./OrganizationStatistic.vue?vue&type=script&lang=js&"
export * from "./OrganizationStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports